import React from "react";
import { PageHeader } from "./PageHeader";

export const HonoraryPatronage = props => {
  var ulSize = {
    fontSize: '18px'
  };
  return (
    <React.Fragment>
      <PageHeader title="Komitety" />
      <div className="content-wrapper">
        <div className="main-content program">
          <h2>Patronat Honorowy</h2>
          <ul style={ulSize}>
            <li>Dr Jarosław Gowin, Minister Nauki i Szkolnictwa Wyższego</li>
            <li>Prof. dr hab. Jacek Majchrowski, Prezydent Miasta Krakowa</li>
            <li>Prof. dr hab Marek Jeżabek, Dyrektor Instytutu Fizyki Jądrowej im. Prof. H. Niewodniczańskiego PAN, Kraków</li>
            <li>Prof. dr hab. inż. Jan Kazior, Rektor Politechniki Krakowskiej</li>
            <li>Prof. dr hab. med. Wojciech Nowak, Rektor Uniwersytetu Jagiellońskiego</li>
            <li>Prof. dr hab. inż. Tadeusz Słomka, Rektor Akademii Górniczo-Hutniczej, Kraków</li>
            <li>Prof. dr hab. Mariusz Wołos, Prorektor ds. Nauki Uniwersytetu Pedagogicznego im. Komisji Edukacji Narodowej w Krakowie</li>
          </ul>

        </div>
      </div>
    </React.Fragment>
  );
};

HonoraryPatronage.propTypes = {};
